// eslint-disable-next-line no-undef
(function ($) {
	$('.cookie-settings-footer-link').on('touchstart click', (e) => {
			e.preventDefault();
			openOneTrustCookieSettings();
	});
	// eslint-disable-next-line no-undef
})(jQuery);